import * as _ from "lodash";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { profileShorthandService } from "../../services/profile-shorthand.service";

export const listProfileShorthandByProfileId = createAsyncThunk(
  "profileShorthandManage/listProfileShorthandByProfileId",
  async ({profileId, search}, { rejectWithValue }) => {
    try {
      const response = await profileShorthandService.listProfileShorthandByProfileId(
        profileId,
        search
      );

      return _.get(response, "data", []);
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const addProfileShorthand = createAsyncThunk(
  "profileShorthandManage/addProfileShorthand",
  async (data, { rejectWithValue }) => {
    try {
      const response = await profileShorthandService.addProfileShorthand(data);

      return _.get(response, "data", {});
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const editProfileShorthand = createAsyncThunk(
  "profileShorthandManage/editProfileShorthand",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const response = await profileShorthandService.editProfileShorthand(
        id,
        data
      );

      return _.get(response, "data", {});
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const removeProfileShorthand = createAsyncThunk(
  "profileShorthandManage/removeProfileShorthand",
  async (id, { rejectWithValue }) => {
    try {
      const response = await profileShorthandService.removeProfileShorthand(id);

      return _.get(response, "data", {});
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
